<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <!-- <div class="bannerFirst" @click="ComeLive"></div> -->
    <div class="commonLiContainer">
      <MyAside></MyAside>
      <div class="commontent">
        <div class="titleMap">消毒防疫机器人</div>
        <!-- <div class="letterTitle">2020/4/12    23:00</div> -->
        <img src="../../assets/images/dsfRobot/dsf_01.png">
        <div class="threediv">
          <h3>1.产品简介</h3>
          <p>武汉优力克智能消毒机器人是一款采用原装进口三维16线激光雷达和最先进的SLAM定位导航算法，定位精度和行走误差毫米级别，轻松应对各种复杂场景。总功率200瓦飞利浦紫外线消毒灯管，秒杀新冠病毒以及其他各种病毒细菌，24伏40安时大功率锂电池模块，保证5小时不间断消杀和续航，可以覆盖1万平方米的消毒作业范围，非常适合图书馆等封闭空间的病毒灭活与消杀，确保人身健康和安全。激光雷达防撞辅以超声波雷达防撞，保证运行设备和设施的安全，友好人机交互界面，方便用户执行消杀任务并检测和追溯运行结果，终生技术服务包括远程技术指导，地图和软件更新，确保用户无后顾之忧。</p>
          <h3>2.产品结构和外形</h3>
          <p><img src="../../assets/images/dsfRobot/dsf_02.png"></p>
          <h3>3.产品尺寸</h3>
          <p><img src="../../assets/images/dsfRobot/dsf_03.png"><img src="../../assets/images/dsfRobot/dsf_04.png"></p>
          <h3>4.主要技术参数</h3>
          <p><img src="../../assets/images/dsfRobot/dsf_05.png"></p>
          <h3>5.消杀效果</h3>
          <p><img src="../../assets/images/dsfRobot/dsf_06.png"></p>
          <h3>6.紫外线灯管</h3>
          <p><img src="../../assets/images/dsfRobot/dsf_07.png"></p>
          <h3>7.核心技术介绍</h3>
          <p>目前市面上普遍为二维激光定位导航，我们采用业界领先的三维激光导航和SLAM 算法！利用时空基准统一构建技术、三维场景构建技术、多传感器组合的时空数据融合等技术，实现机器人高精度自主定位、自主导航、智能避障等功能，完成机器人的自主运动需求</p>
          <p>SLAM指的是机器人在自身位置不确定的条件下，在完全未知的环境下同时建立地图以及自主定位。不同于竞品的2D-SLAM，我们使用多线激光，可以在室内外，地面有凹凸不平等各种环境下实时建立三维点云地图，在没有闭环约束的情况下依然可以达到厘米级点云地图构建，以及厘米级定位。算法主要分为IMU姿态解算、姿态更新、激光帧组合、SLAM融合四个部分。</p>
          <p><img src="../../assets/images/dsfRobot/dsf_08.png"></p>
          <h3>实践效果</h3>
          <div class="part-wrap">
            <h4>1).适应更多的场景变化</h4>
            <p>二维激光只能扫描到同等高度的物体，因此如果草木生长及衰退影响到了自身高度，又或者货架上停放了物品及未停放物品导致高 度变化，以及类似的其他很多情况，使得二维激光的定位导航出现碰到障碍 物、错误规划路线、定位错误等问题。</p>
          </div>
          <div class="part-wrap">
            <h4>2).路径规划效率更智能</h4>
            <p>避障效果更好。二维精光导引智能检测单一高度的障 碍物，容易将斜坡误判为障碍物，三维激光导引能有效地检测地面，同时能有 效地避开不同高程的障碍物。</p>
          </div>
          <div class="part-wrap">
            <h4>3).定位精度更高</h4>
            <p>三维激光扫描的点云更多，匹配效果更好，定位精度也更高。</p>
          </div>
          <div class="part-wrap">
            <h4>4).支持上下坡</h4>
            <p>二维激光导引以运动平面水平为假设，在非平面场景会出现定 位偏差甚至错误，三维激光导引能精确的计算倾角和高度，满足机器人在非平 面场景下的定位导航。</p>
          </div>
          <div class="part-wrap">
            <h4>5).建图更丰富</h4>
            <p>二维激光建图为平面，某些需要辨识的建筑或物体不能很好区 分。三维激光建图为 3D，可旋转，场景辨识度更好，还能接入VR，展示效果。</p>
          </div>
          <div class="part-wrap">
            <h4>6).提供机器人6自由度位姿</h4>
            <p>相比二维3自由度，更能满足二次开发或其他位姿相关业务需求。</p>
          </div>
          <div class="part-wrap">
            <h4>7).多线激光</h4>
            <p>多线激光与单线激光价格持平但扫描距离更远，范围更大，点频更高。</p>
          </div>
          <div class="part-wrap">
            <h4>8).全天时工作</h4>
            <p>相比于依靠视觉定位的机器人只能在室内使用，我们的物流机器人可以室内、室外通用。可以在-10℃~55℃的环境下正常工作，防水防尘等级达到 IP65。 且在满载状态下可自由行驶通过20°以内的坡道，搭载的阿克曼轮底盘最大涉水深度120mm。</p>
          </div>          
          <h3>8.基本功能</h3>
          <div class="part-wrap">
            <h5>1).三维地图构建、定位与导航（3D-SLAM）</h5>
            <h5>2).三维高精度导航地图绘制及三维场景建模</h5>
            <h5>3).自主跟随行进、自主设定机器人行进路线</h5>
            <h5>4).人机交互界面，支持编辑机器人运行停靠点</h5>
            <h5>5).支持自主避障和避停</h5>
            <h5>6).支持报警提醒</h5>
            <h5>7).机器人行驶过程中支持人工紧急避停</h5>
          </div>
          <h3>9.产品优势</h3>
          <div class="part-wrap">
            <h4>1).操作简便</h4>
            <p>界面直观的触屏操作</p>
            <p>任何指派 ，一步搞定</p>
            <p>支持遥控器、手机、平板、电脑等多终端操作</p>
          </div> 
          <div class="part-wrap">
            <h4>2).性价比高</h4>
            <p>可靠的质量控制体系</p>
            <p>高效的调度方案</p>
            <p>自主知识产权</p>
          </div>
          <div class="part-wrap">
            <h4>3).部署容易</h4>
            <p>无轨智能导航技术，无需场景改造</p>
            <p>一次性创建现场环境地图</p>
            <p>新场景，一小时内完成部署</p>
          </div>
          <div class="part-wrap">
            <h4>4).提供延申服务</h4>
            <p>全套解决方案和完善的售后服务体系</p>
            <p>提供机器人租赁业务</p>
            <p>可以为用户提供消杀防疫服务</p>
          </div> 
          <h3>10.典型应用</h3>  
          <p><img src="../../assets/images/dsfRobot/dsf_09.png"></p>
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import MyAside from '@/components/MyAside.vue'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      ComeLive() {
        // 1、后台如果设置了默认直播，就传过去默认直播的id，否则就传0
        // 2、HomePage: true; 用来判断是不是从首页进入的，
        // 首页进来的话，优先播放和服务器时间对的上的直播，
        // 其次是查看有没有默认直播，
        // 上面都没有满足的话就展示没有直播提醒的提示
        // 3、直播页中直接点击议程跳转到新的页面，就展示点击的议程的直播 Cookies.set('linkUrl', item.linkUrl) Cookies.get('linkUrl')
        this.$router.push({ name: 'LookLiveG', params: { webinarId: 0 } })
        Cookies.set('HomePage', true)
        Cookies.set('playType', 1)
        Cookies.set('playUrl', 'null')
      }
    },
    components: {
      BottomComponent,
      TopComponent,
      [MyAside.name]: MyAside
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .bannerFirst {
    height: 67px;
    cursor: pointer;
    background: url('../../assets/images/NewBanner.png') no-repeat center center;
    background-size: auto 100%;
  }

  /* 公共 */
  .commonLiContainer {
    display: flex;
    justify-content: center;
    padding: 60px 50px;
    background-color: #FFDDB0;
  }

  .commontent {    
    padding: 50px;
    width: 1000px;
    background-color: #fff;
    font-family: PingFang-SC-Bold;
  }

  /* title */
  .titleMap {
    color: #000;
    font-size: 30px;
    padding-bottom: 30px;
  }

  .letterTitle {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 68px;
  }

  /* 1 */
  .twodiv {
    color: #333;
    font-size: 16px;
    margin-top: 10px;
    line-height: 25px;
    text-align: left;
  }

  /* 2 */
  .threediv {
    margin: 20px auto;
    h3{
        padding: 10px 0 15px;
    }
    p{
        padding:18px 0;
        font-size:14px;
        line-height:24px;
    }
    .part-wrap{
        padding-left: 20px;
        h5{
            font-weight: normal;
            font-size:14px;
            padding:5px 0px;
        }
        p{
            padding:8px 0 8px 20px;
        }
    }
  }

  img {
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Dsf-Robot.vue